import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { resetPassword } from '@aws-amplify/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocaleService } from 'src/app/services/locale';
import { InputComponent } from '../shared/input';
import { ButtonComponent } from '../shared/button';

@Component({
  selector: 'app-forgot',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    InputComponent,
    ButtonComponent
  ],
  template: `
    <div class="flex flex-col gap-3 sm:gap-4 mb-4 sm:mb-6">
      <h1 class="text-xl sm:text-2xl lg:text-3xl font-bold futura text-[#043B22]">
        {{ locale.forgot_password.heading }}
      </h1>
      <p class="text-xs sm:text-sm text-[#616161]">
        {{ locale.forgot_password.subheading || 'Inserisci il tuo indirizzo email per ricevere il codice di verifica.' }}
      </p>
    </div>
    <form [formGroup]="form" (submit)="submit()" class="flex flex-col gap-3 sm:gap-4">
      <app-input
        [keyUp]="reset"
        type="email"
        placeholder="{{ locale.common.placeholder_email }}"
        label="{{ locale.common.lbl_email }}"
        [control]="form.controls['email']"
      ></app-input>
      <div *ngIf="error.length" class="text-red-500 text-xs sm:text-sm bg-red-50 p-3 rounded-lg">
        {{ error }}
      </div>
      <div class="mt-1 sm:mt-2">
        <app-button
          [disabled]="form.invalid"
          text="{{ locale.forgot_password.button_send_code }}"
        ></app-button>
      </div>
      <div class="flex w-full justify-center mt-2">
        <a
          routerLink="/login"
          class="text-xs sm:text-sm text-[#616161] hover:text-[#043B22] cursor-pointer transition-colors"
        >
          {{ locale.forgot_password.button_back_to_login }}
        </a>
      </div>
    </form>
  `
})
export class ForgotComponent {
  private router: Router = inject(Router);
  private spinner = inject(NgxSpinnerService);
  private localeService = inject(LocaleService);

  locale = this.localeService.locale();

  error = '';

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)])
  });

  constructor() {}

  reset = () => {
    this.error = '';
  };

  submit = async () => {
    try {
      this.spinner.show();

      const credentials = {
        username: this.form.controls.email.value as string
      };

      await resetPassword(credentials);

      this.spinner.hide();

      // Store username in sessionStorage for page refresh scenarios
      sessionStorage.setItem('resetPasswordUsername', credentials.username);

      return this.router.navigate(['/confirm'], {
        state: { username: credentials.username }
      });
    } catch (error) {
      this.spinner.hide();
      this.error = (error as any).message;
      return;
    }
  };
}
